// Feature: M004-F0717. Tests: T-M004-0217, T-M004-0218.
//
// The wire of the transaction calendar: Spec core-ledger-account-gateway 1.5.0 (digest 3014cc73...),
//   listBillingTransactions  GET /v1/orgs/{orgId}/billing/transactions?from&to&room_id&kind&cursor&limit
//   guard billing.view + membership, window at most 62 days, keyset paging (truncated + next_cursor), no-store.
// The paging follows ACCT-TX-012: the read never cuts silently, so this reader follows next_cursor while `truncated`
// is true (at most TX_LIST_MAX_PAGES pages) and reports `capped: true` when the cap was hit with more still to read.
export const TX_WINDOW_MAX_DAYS = 62;
export const TX_LIST_LIMIT = 1000;
export const TX_LIST_MAX_PAGES = 8;

export function buildTxCalendarApi(http) {
  return {
    list: (orgId, params) => http.get(`/v1/orgs/${encodeURIComponent(orgId)}/billing/transactions`, { params }),
  };
}

const unwrap = (response) => {
  const body = response?.data;
  if (body && typeof body === 'object' && !Array.isArray(body) && 'data' in body) return body.data;
  return body ?? null;
};

// Reads the whole window. Throws when a page fails or answers a shape the contract does not declare (never a
// partial grid presented as complete). Result: { entries, pages, capped }.
export async function readTransactionWindow({ orgId, from, to, limit = TX_LIST_LIMIT }, api) {
  const entries = [];
  let cursor = null;
  let pages = 0;
  for (;;) {
    const params = { from, to, limit };
    if (cursor) params.cursor = cursor;
    // eslint-disable-next-line no-await-in-loop
    const data = unwrap(await api.list(orgId, params));
    if (!data || !Array.isArray(data.entries) || typeof data.truncated !== 'boolean') {
      throw new Error('The transactions read did not answer the declared shape.');
    }
    pages += 1;
    entries.push(...data.entries);
    if (!data.truncated) return { entries, pages, capped: false };
    if (typeof data.next_cursor !== 'string' || !data.next_cursor) {
      throw new Error('The transactions read said more exist but gave no cursor.');
    }
    if (pages >= TX_LIST_MAX_PAGES) return { entries, pages, capped: true };
    cursor = data.next_cursor;
  }
}
